import { App, Button, Card, Col, Popconfirm, Row, Spin } from 'antd';
import { StyledTableWrapper } from 'components/table/table.styled';
import dayjs from 'dayjs';
import { StatusBadge } from 'features/Dashboard/ui/StatusBadge';
import { useDeleteDocument } from 'features/document-report/use-cases/delete-document';
import FileViewer from 'features/new-clients/components/clients-details/file-viewer';
import { usePermissions, useUserContext } from 'features/users';
import { Download, RotateCcw, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { downloadDocument, formatUtcToLocal } from 'routes/utils';

export const LegalTable = ({
  dataList,
  isLoading,
  setShowModal,
  setTitleDocuments,
  setShowUploadModal,
  refetch,
}: // tableParams,
// updateParams,
any) => {
  const permissions = usePermissions();
  const { user } = useUserContext();
  const { message } = App.useApp();
  const { mutate: deleteDocMutate } = useDeleteDocument();
  const [isload, setIsLoad] = useState(false);

  if (!permissions) return null;

  const handleClickRefresh = async () => {
    try {
      setIsLoad(true); // Start loading
      await refetch(); // Wait for `intialFetch` to complete
    } catch (error) {
      console.error('Error during refresh:', error); // Handle errors
    } finally {
      setIsLoad(false); // Stop loading regardless of success or error
    }
  };

  const handleDelete = (item: any) => {
    const docId = item?.documentId || item?.DocumentId;
    if (!docId) {
      message.error('Document ID not found');
      
return;
    }

    const loggedInUserId =
      localStorage.getItem('userId') || user?.Id || user?.id || '';

    deleteDocMutate(
      {
        LoggedInUserId: loggedInUserId as string,
        DocumentId: docId,
        IsAdmin: false,
      },
      {
        onSuccess: (res: any) => {
          if (res?.rs === 1 || res?.status === 1) {
            message.success('Document deleted successfully');
            refetch();
          } else {
            message.error(res?.rm || 'Failed to delete document');
          }
        },
      },
    );
  };

  return (
    <StyledTableWrapper className='legl_tab'>
      {/* <StyledTableHeader></StyledTableHeader> */}
      {isLoading ? (
        <Spin className='spnldrbx' />
      ) : (
        <div className='bg-white p-4 rounded-lg'>
          <div className='flex-col gap-2 justify-between sm:flex md:flex-row flex mb-5'>
            <h3 className='text-xl text-[#313030] font-semibold'>Documents</h3>
            <div className='flex src_flter space-x-4'>
              <Button type='primary' onClick={() => setShowUploadModal(true)}>
                Upload Document
              </Button>
              <Button
                type='primary'
                loading={isload}
                onClick={handleClickRefresh}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isload ? null : <RotateCcw />}
              </Button>
            </div>
          </div>

          <Row gutter={[16, 16]}>
            {dataList?.map((item: any, index: any) => (
              <Col key={index} xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                <Card
                  role='button'
                  bordered
                  className='bg-[#F6F7F9] lgl_crd border-0 h-full'
                >
                  <div className='flex gap-3 relative'>
                    <div className='relative'>
                      <figure className='mediafolder'>
                        <FileViewer
                          documentPath={item.documentPath}
                          documentName={item.documentName}
                        />
                      </figure>
                    </div>
                    <div className='flex flex-col grow'>
                      <p className='font-bold'>{item.documentName}</p>

                      <p className='text-xs text-gray-500 mb-1'>
                        {item?.uploadedOn !== null && (
                          <span>
                            {formatUtcToLocal(
                              dayjs(item?.lastUpdatedDate).format(
                                'DD-MMM-YYYY',
                              ),
                            )}
                          </span>
                        )}
                      </p>

                      <p className='text-xs text-gray-500 font-semibold mb-1'>
                        {item?.comments && (
                          <span>Comments: {item?.comments}</span>
                        )}
                      </p>

                      <p className='text-xs text-gray-500 font-semibold mb-2'>
                        {item?.reason && <span>Reason: {item?.reason}</span>}
                      </p>

                      <div className='flex gap-3 align-middle justify-between mt-1'>
                        {item?.status && <StatusBadge status={item.status} />}
                        {(item?.status === 'Reject' ||
                          item?.status === null) && (
                          <Button
                            type='primary'
                            className='inline-block px-2 py-1 text-xs font-semibold rounded border'
                            onClick={() => {
                              setTitleDocuments(item);
                              setShowModal(true);
                            }}
                          >
                            Upload Again
                          </Button>
                        )}

                        <div className='absolute right-3 top-3 flex items-center gap-2'>
                          {item?.documentPath && (
                            <span
                              className='cursor-pointer text-gray-600 hover:text-blue-600'
                              onClick={() =>
                                downloadDocument(
                                  item?.documentPath,
                                  item?.documentName,
                                )
                              }
                              title='Download Document'
                            >
                              <Download size={18} />
                            </span>
                          )}

                          {(item?.documentId || item?.DocumentId) &&
                            (item?.status === 'Pending' ||
                              item?.documentStatusId === 1) && (
                              <Popconfirm
                                title='Delete Document'
                                description={`Are you sure you want to delete "${item.documentName}"?`}
                                onConfirm={() => handleDelete(item)}
                                okText='Yes'
                                cancelText='No'
                              >
                                <span
                                  className='cursor-pointer text-red-500 hover:text-red-700'
                                  title='Delete Document'
                                >
                                  <Trash2 size={18} />
                                </span>
                              </Popconfirm>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </StyledTableWrapper>
  );
};
